package com.qrkontaq.ui.map

import kotlinx.browser.document
import kotlinx.browser.window
import kotlin.coroutines.resume
import kotlin.coroutines.suspendCoroutine

/** Clean CARTO "Voyager" basemap URL; `{r}` pulls sharp retina tiles. */
internal const val CARTO_VOYAGER_TILES =
    "https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png"

/** Load Leaflet CSS + JS from the CDN once; suspends until the global `L` is ready. */
internal suspend fun ensureLeaflet() {
    if (document.getElementById("qk-leaflet-css") == null) {
        val link = document.createElement("link")
        link.setAttribute("id", "qk-leaflet-css")
        link.setAttribute("rel", "stylesheet")
        link.setAttribute("href", "https://unpkg.com/leaflet@1.9.4/dist/leaflet.css")
        document.head?.appendChild(link)
    }
    if (jsTypeOf(window.asDynamic().L) != "undefined") return
    suspendCoroutine<Unit> { cont ->
        val existing = document.getElementById("qk-leaflet-js")
        if (existing != null) {
            existing.addEventListener("load", { cont.resume(Unit) })
        } else {
            val script = document.createElement("script")
            script.setAttribute("id", "qk-leaflet-js")
            script.setAttribute("src", "https://unpkg.com/leaflet@1.9.4/dist/leaflet.js")
            script.addEventListener("load", { cont.resume(Unit) })
            document.head?.appendChild(script)
        }
    }
}
